module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/cznBux/tc-custom/9781685502683.jpg?1728725961541",
      "alt": "This image is the cover for the book The Wasteland Kings"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Wasteland Kings\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Hacker Bast has it all: a cushy condo, a sexy boyfriend, and a place among the wealthy elite. When his past catches up with him, he flees into the dreary and dangerous wastelands between domed cities. There he meets Delphi, who saves him, and Galeron, who runs a small town. He is anything but safe, however, as robotic “dogs” roam the countryside, looking for people to kill, and humans can be just as deadly."), _c('br'), _c('br'), _vm._v("As Bast settles in to life in the town, he develops a controversial relationship with Galeron. They fall in love, but all is not well in their world. Can the two of them survive and reach the happy ending they long for, or will the wastelands take everything they hold dear?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jaimie N. Schock\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0